var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyViolateBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.57722 22.5926C9.81893 22.5926 11.6362 20.8167 11.6362 18.6259C11.6362 16.4351 9.81893 14.6592 7.57722 14.6592C5.33551 14.6592 3.51825 16.4351 3.51825 18.6259C3.51825 20.8167 5.33551 22.5926 7.57722 22.5926Z",
    fill: "#8BBDFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.57727 23.8059C2.12231 23.8059 0 27.441 0 29.1318C0 30.8226 4.51692 31.2727 7.57727 31.2727C10.6376 31.2727 15.1545 30.8226 15.1545 29.1318C15.1545 27.441 13.0329 23.8059 7.57727 23.8059Z",
    fill: "#8BBDFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.525 22.5926C18.7667 22.5926 20.584 20.8167 20.584 18.6259C20.584 16.4351 18.7667 14.6592 16.525 14.6592C14.2833 14.6592 12.4661 16.4351 12.4661 18.6259C12.4661 20.8167 14.2833 22.5926 16.525 22.5926Z",
    fill: "#3180F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.5251 23.8059C11.0702 23.8059 8.94788 27.441 8.94788 29.1318C8.94788 30.8226 13.4648 31.2727 16.5251 31.2727C19.5855 31.2727 24.1024 30.8226 24.1024 29.1318C24.1024 27.441 21.9808 23.8059 16.5251 23.8059Z",
    fill: "#3180F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.8321 12.683C24.2379 12.945 24.7618 12.945 25.1675 12.683C26.4556 11.8511 29.2629 9.86403 30.4715 7.63988C32.0656 4.70586 30.1936 1.77954 27.7198 1.77954C26.3094 1.77954 25.4608 2.49967 24.9916 3.11865C24.7445 3.44481 24.2559 3.44481 24.0084 3.11865C23.5393 2.49967 22.6906 1.77954 21.2803 1.77954C18.8064 1.77954 16.9344 4.70586 18.5285 7.63988C19.7368 9.86366 22.544 11.8511 23.8321 12.683Z",
    fill: "#80C8FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyViolateBlue);
export default __webpack_public_path__ + "static/media/daily_violate_blue.4f37800326bcdeea963075860a25fd57.svg";
export { ForwardRef as ReactComponent };